import apiInstance from "../configs/ApiInstance";

const GetAdminImage = async (key) => {
    const response = await apiInstance.adminService.get(`${key}`);
    const imageUrl = response.data.url;
    return imageUrl;
}

export default GetAdminImage;